import RutFormatter from './RutFormatter'
import RucFormatter from './RucFormatter'
import { CHILE, PERU } from "../../constants";

const countriesFormatMap = {
  [CHILE.value]: RutFormatter,
  [PERU.value]: RucFormatter,
}

const CountryDocNumberFormatter = {
  format: country => countryDocNumber => {
    const format = countriesFormatMap[country]
    return format !== undefined ? format(countryDocNumber) : countryDocNumber
  },
};

export default CountryDocNumberFormatter